import { categoryItems } from "../enum";

export const dashboardLinks = [
  {
    type: categoryItems[0],
    title: "سفر و گردشگری",
    links: [
      {
        title: "هتل",
        logo: "hotel.png",
        url: "hotels",
        // permission: "canHotel",
      },
      { title: "پرواز داخلی", logo: "fly.png", url: "flights" },
      { title: "پرواز خارجی", logo: "globe.png", url: "flights" },
      { title: "تور", logo: "camera.png", url: "" },
      { title: "ویلا و اقامتگاه", logo: "home-tree.png", url: "" },
      { title: "اتوبوس", logo: "mini-bus.png", url: "" },
    ],
  },
  {
    type: categoryItems[1],
    title: "خدمات کاربردی روزانه",
    links: [
      { title: "کارباما", logo: "karbama.png", url: "" },
      { title: "تعویض روغن اتومبیل", logo: "roghan.png", url: "" },
      { title: "کارواش", logo: "karwash.png", url: "" },
      {
        title: "سالن زیبایی آقایان و بانوان",
        logo: "salon-zibaye.png",
        url: "",
      },
    ],
  },
  {
    type: categoryItems[2],
    title: "خرید لوازم منزل",
    links: [
      { title: "دیجی پی", logo: "digi-pay.png", url: "" },
      { title: "دیجی قسطی", logo: "digighesti.png", url: "" },
      { title: "اسنپ پی", logo: "snapp-pay.png", url: "" },
    ],
  },
  {
    type: categoryItems[3],
    title: "خرید ارزاق",
    links: [
      { title: "هایپر استار", logo: "hayperstar.png", url: "" },
      { title: "رفاه", logo: "refah.png", url: "" },
      { title: "گامبرون", logo: "gambron.png", url: "" },
    ],
  },
  {
    type: categoryItems[4],
    title: "ورزش، تفریح و سرگرمی",
    links: [
      { title: "استخر", logo: "estaghr.png", url: "" },
      { title: "ماساژ", logo: "masazh.png", url: "" },
      { title: "مجموعه توسکا", logo: "toska.png", url: "" },
      { title: "مجموعه گوین", logo: "gevin.png", url: "" },
      { title: "تناسب اندام", logo: "tanasob-andam.png", url: "" },
      { title: "سینما تیکت", logo: "cinema-ticket.png", url: "" },
      { title: "ایران کنسرت", logo: "ghoghnos.png", url: "" },
      {
        title: "تفریحات دریایی مانگرو",
        logo: "mangro.png",
        url: "",
      },
      { title: "فیلیمو", logo: "filimo.png", url: "" },
      { title: "فیلم نت", logo: "filmnet.png", url: "" },
      { title: "نماوا", logo: "namava.png", url: "" },
    ],
  },
  {
    type: categoryItems[5],
    title: "سبک زندگی و خانواده",
    links: [
      { title: "خانومی", logo: "khanomi.png", url: "" },
      { title: "بانی مد", logo: "banimode.png", url: "" },
      { title: "چرم مشهد", logo: "charm-mashhad.png", url: "" },
      { title: "باتیک", logo: "batik.png", url: "" },
      { title: "بوفالو سیاه", logo: "bofalo-siah.png", url: "" },
      { title: "جین وست", logo: "jeanwest.png", url: "" },
      { title: "هاکوپیان", logo: "hacoupian.png", url: "" },
      { title: "ال سی من", logo: "lcman.png", url: "" },
      { title: "گراد", logo: "gerad.png", url: "" },
      { title: "نوشت افزار", logo: "neveshtafzar.png", url: "" },
      { title: "کودک من", logo: "koodakman.png", url: "" },
      { title: "عسل بانو", logo: "asalbano.png", url: "" },
      { title: "شاپرک", logo: "shaparak.png", url: "" },
    ],
  },
  {
    type: categoryItems[6],
    title: "آموزش و توانمندسازی",
    links: [
      { title: "بوکتاب", logo: "booktob.png", url: "" },
      { title: "بوکلند", logo: "bookland.png", url: "" },
      { title: "فیدیبو", logo: "fidibo.png", url: "" },
      { title: "طاقچه", logo: "taghche.png", url: "" },
      { title: "تیکا", logo: "tika.png", url: "" },
      { title: "کیدز", logo: "kids.png", url: "" },
      { title: "فیلیمو مدرسه", logo: "filimo-madreseh.png", url: "" },
    ],
  },
  {
    type: categoryItems[7],
    title: "هدایای مناسبتی",
    links: [
      { title: "شب یلدا", logo: "shab-yalda.png", url: "" },
      { title: "عید نوروز", logo: "eyd-nowroz.png", url: "" },
      { title: "سالگرد ازدواج", logo: "salgard-ezdevaj.png", url: "" },
      { title: "روز تولد", logo: "roz-tavalod.png", url: "" },
      { title: "روز مرد", logo: "roz-mard.png", url: "" },
      { title: "روز زن", logo: "womens-day.png", url: "" },
      { title: "روز کارگر", logo: "roz-kargar.png", url: "" },
    ],
  },
];
